import React, { Component, useState } from 'react';
import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../i18n";

import { View, Text, Image, ActivityIndicator} from "react-native-web";

import HamburgerMenu from 'react-hamburger-menu';

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function FooterMobile(props) {
  const currentYear = new Date().getFullYear();
  const [open, setOpen] = useState(false);
   const navigate = useNavigate();

   const location = useLocation();

   let pathname = location.pathname;


   const handleClick = () => {
       let bool = !open;
       setOpen(bool);

       props.handleMenuClick(bool);
   }

    return (

      <div style={{backgroundColor: '#fff'}}>

         <div style={{height: '100px'}}/>

         {i18n.language == 'en' &&
            <div style={{width: '94%', margin: 'auto', fontSize: '16px', fontFamily: 'Roboto', paddingTop: '20px', textAlign: 'center', borderTop: '1px solid #ccc'}}>
                <div>© {currentYear} · Yeqola, a product of <a href="https://www.debyoo.com" target="_blank" style={{color: '#5800d9'}}>Debyoo</a></div>
                <div style={{marginTop: '6px'}}><a href="/help" style={{color: '#5800d9'}}>Help</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/privacy" style={{color: '#5800d9'}}>Privacy</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/terms" style={{color: '#5800d9'}}>Terms of use</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="https://www.debyoo.com/contact" target="_blank" style={{color: '#5800d9'}}>Contact</a></div>
           </div>
         }

         {i18n.language == 'fr' &&
            <div style={{width: '94%', margin: 'auto', fontSize: '16px', fontFamily: 'Roboto', paddingTop: '20px', textAlign: 'center', borderTop: '1px solid #ccc'}}>
                <div>© {currentYear} · Yeqola, un produit de <a href="https://www.debyoo.com" target="_blank" style={{color: '#5800d9'}}>Debyoo</a></div>
                <div style={{marginTop: '6px'}}><a href="/help" style={{color: '#5800d9'}}>Aide</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/privacy" style={{color: '#5800d9'}}>Confidentialité</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/terms" style={{color: '#5800d9'}}>Termes d'utilisation</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="https://www.debyoo.com/contact" target="_blank" style={{color: '#5800d9'}}>Contact</a></div>
           </div>
         }

         <div style={{height: '30px'}}/>

      </div>

    )

}
